import React from 'react'

export default function FormPageSkeleton() {
  return (
    <div className="min-h-[60vh] animate-fade-in">
      <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-12">
        {/* Breadcrumb skeleton */}
        <div className="flex items-center gap-2 mb-6">
          <div className="skeleton h-4 w-14 rounded-full" />
          <div className="skeleton h-3 w-3 rounded-full" />
          <div className="skeleton h-4 w-20 rounded-full" />
          <div className="skeleton h-3 w-3 rounded-full" />
          <div className="skeleton h-4 w-16 rounded-full" />
        </div>

        {/* Header skeleton */}
        <div className="flex items-start gap-3 mb-8">
          <div className="skeleton h-11 w-11 rounded-xl flex-shrink-0" />
          <div className="space-y-2 flex-1">
            <div className="skeleton h-8 w-56 rounded-lg" />
            <div className="skeleton h-4 w-72 rounded" />
          </div>
        </div>

        {/* Form card skeleton */}
        <div className="card p-5 sm:p-8 space-y-0 divide-y divide-border">
          {/* Section 1: Details */}
          <div className="pb-6 sm:pb-8">
            <div className="space-y-5">
              <div className="flex items-center gap-3">
                <div className="skeleton h-8 w-8 rounded-full" />
                <div className="space-y-1.5">
                  <div className="skeleton h-4 w-28 rounded" />
                  <div className="skeleton h-3 w-44 rounded" />
                </div>
              </div>
              <div className="space-y-4">
                <div className="space-y-2">
                  <div className="skeleton h-4 w-12 rounded" />
                  <div className="skeleton h-[52px] w-full rounded-xl" />
                </div>
                <div className="space-y-2">
                  <div className="skeleton h-4 w-20 rounded" />
                  <div className="skeleton h-28 w-full rounded-xl" />
                </div>
              </div>
            </div>
          </div>

          {/* Section 2: Location / Dates */}
          <div className="py-6 sm:py-8">
            <div className="space-y-5">
              <div className="flex items-center gap-3">
                <div className="skeleton h-8 w-8 rounded-full" />
                <div className="space-y-1.5">
                  <div className="skeleton h-4 w-24 rounded" />
                  <div className="skeleton h-3 w-48 rounded" />
                </div>
              </div>
              <div className="skeleton h-[280px] w-full rounded-xl" />
            </div>
          </div>

          {/* Section 3: Photos */}
          <div className="py-6 sm:py-8">
            <div className="space-y-5">
              <div className="flex items-center gap-3">
                <div className="skeleton h-8 w-8 rounded-full" />
                <div className="space-y-1.5">
                  <div className="skeleton h-4 w-16 rounded" />
                  <div className="skeleton h-3 w-52 rounded" />
                </div>
              </div>
              <div className="skeleton h-36 w-full rounded-xl" />
              <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
                <div className="skeleton aspect-square rounded-xl" />
                <div className="skeleton aspect-square rounded-xl" />
                <div className="skeleton aspect-square rounded-xl hidden sm:block" />
              </div>
            </div>
          </div>

          {/* Section 4: Verification */}
          <div className="pt-6 sm:pt-8">
            <div className="space-y-5">
              <div className="flex items-center gap-3">
                <div className="skeleton h-8 w-8 rounded-full" />
                <div className="space-y-1.5">
                  <div className="skeleton h-4 w-24 rounded" />
                  <div className="skeleton h-3 w-56 rounded" />
                </div>
              </div>
              <div className="skeleton h-16 w-64 rounded-lg" />
            </div>
          </div>
        </div>

        {/* Submit area skeleton */}
        <div className="mt-6 flex flex-col-reverse sm:flex-row sm:justify-end gap-3">
          <div className="skeleton h-12 w-full sm:w-32 rounded-xl" />
          <div className="skeleton h-12 w-full sm:w-40 rounded-xl" />
        </div>
      </div>
    </div>
  )
}
